/* eslint-disable class-methods-use-this */
import packageConfig from './packageConfig';
import getEnvVariable from './environment';
import { ENVIRONMENT } from '../constants';

let packageId = '';

class AdsPackage {
  constructor() {
    Object.assign(this, packageConfig.adsDefaultPackage);
    packageId = getEnvVariable(ENVIRONMENT.ADS_PACKAGE_ID);
  }

  get id() {
    return packageId;
  }
}

export default AdsPackage;
